import useTranslation from "next-translate/useTranslation";
import { SwiperSlide } from "swiper/react";
import OpportunityCard from "@/components/become-consultant/OpportunityCard";
import useIsMobile from "@/common/hook/useIsMobile";
import Slider from "@/components/common/Slider";

const YourOpportunities = ({ opportunities = [] }) => {
  const { t } = useTranslation("become-consultant");
  const isMobile = useIsMobile();

  return (
    <section className="container py-12 lg:py-32">
      <h2 className="text-center text-xl font-semibold lg:text-4xl">{t`your-opportunities.title`}</h2>
      <p className="mt-2 text-center text-xs text-grey-700 lg:mt-3 lg:text-base">{t`your-opportunities.subtitle`}</p>
      {isMobile ? (
        <Slider slidesPerView={1.5}>
          {opportunities.map((opportunity) => (
            <SwiperSlide key={opportunity.id} className="py-4">
              <OpportunityCard opportunity={opportunity} />
            </SwiperSlide>
          ))}
        </Slider>
      ) : (
        <div className="mt-12 grid grid-cols-2 gap-16 lg:grid-cols-4">
          {opportunities.map((opportunity) => (
            <OpportunityCard key={opportunity.id} opportunity={opportunity} />
          ))}
        </div>
      )}
    </section>
  );
};

export default YourOpportunities;
